import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { capitalize } from 'lodash';

import Divider from 'components/shared/Divider/Divider';
import ColorPicker from 'components/shared/ColorPicker/ColorPicker';
import SectionList from 'components/practice/UserPreferences/components/SectionList';

import Input from '../../../../../../shared/Input/Input';
import Select from '../../../../../../shared/Select/Select';
import { confirmKioskCode } from '../../../../../../../api/Kiosk';
import Textarea from '../../../../../../shared/Textarea/Textarea';
import VerificationCode from '../../../../../../shared/VerificationCode/VerificationCode';

export default function NewKiosk({ formik, status, setStatus, setConfirmedKiosk, practitioners }) {
  const navigate = useNavigate();
  const outletContext = useOutletContext();

  const submitCode = async (newCode) => {
    setStatus('loading');
    const data = await confirmKioskCode(navigate, {
      practiceId: outletContext?.practiceId,
      code: newCode
    });
    if (data?.kiosk) {
      setStatus('success');
      setConfirmedKiosk(data.kiosk);
    } else {
      setStatus('error');
    }
  };

  const statuses = [
    {
      value: 'active',
      label: 'Active'
    },
    {
      value: 'inactive',
      label: 'Inactive'
    }
  ];

  return (
    <>
      <SectionList
        title="Add new kiosk"
        description="To add a new kiosk please prompt a verification code from the kiosk and enter below.">
        <VerificationCode onComplete={submitCode} status={status} setStatus={setStatus} />
      </SectionList>
      <Divider className="my-6" />
      <SectionList
        className="gap-3"
        title="Basic information"
        description="Manage your basic details to keep your profile accurate and up to date.">
        <div className="flex gap-2">
          <ColorPicker
            color={formik?.values?.color}
            onChange={(color) => formik.setFieldValue('color', color)}
          />
          <Input
            name="name"
            className="flex-1"
            label="Name"
            type="text"
            placeholder="Enter kiosk name"
            required
            value={formik?.values?.name}
            error={formik?.errors?.name}
            onChange={formik && formik?.handleChange}
          />
          <Select
            name="status"
            label="Status"
            className="flex-1"
            options={statuses}
            type="text"
            placeholder="Type and select kiosk status"
            required
            value={formik?.values?.status ? { label: capitalize(formik?.values?.status) } : null}
            error={formik?.errors?.status}
            isClearable={false}
            onChange={({ value }) => formik?.setFieldValue('status', value)}
          />
        </div>

        <Textarea
          name="description"
          isOptional
          label="Description"
          placeholder="Enter kiosk description"
          textareaClassName="!h-24"
          rows={3}
          value={formik?.values?.description}
          onChange={formik && formik?.handleChange}
        />

        <Select
          name="notify_users"
          label="Members that will be notified for this kiosk's requests"
          className="flex-1"
          isMulti
          options={practitioners}
          type="text"
          placeholder="Type and select members"
          value={formik?.values?.notify_users}
          error={formik?.errors?.notify_users}
          isClearable={false}
          onChange={(value) => formik?.setFieldValue('notify_users', value)}
        />
      </SectionList>
    </>
  );
}
